<template>
  <messagePopup
    :dialog-title="title"
    :dialog-type="''"
    :append-to-body="true"
    :show-close="showClose"
    :center-dialog-visible="dialogVisible"
    :popup-width="'750px'"
    :popup-top="'10vh'"
    :show-btn="false"
  >
    <div class="content" v-html="content"></div>
    <div class="button">
      <div class="btn reset-btn" @click="handleOpera">{{ btnTxt }}</div>
    </div>
  </messagePopup>
</template>

<script>
import messagePopup from './e-messagePopup.vue';

export default {
  components: { messagePopup },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    content: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    showClose: {
      type: Boolean,
      default: false,
    },
    btnTxt: {
      type: String,
      default: '已阅读',
    },
    type: {
      type: String,
      default: '',
    },
  },
  methods: {
    handleOpera() {
      const { type } = this;
      // 操作
      this.$emit('change', type);
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  ::v-deep .box {
    color: #333;
    padding: 0px 30px;
    box-sizing: border-box;
    .fontWeight {
      font-weight: bold;
    }
    .box-title {
      width: 100%;
      display: flex;
      font-size: 16px;
      margin-bottom: 20px;
      font-weight: bold;
      justify-content: center;
    }
    p {
      text-indent: 32px;
    }
    .box-text {
      text-indent: 2em;
      line-height: 24px;
    }
    .box-end {
      text-align: right;
      line-height: 24px;
    }
  }
}
.button {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
  .btn {
    width: 80px;
    text-align: center;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
  }

  .reset-btn {
    background: #ffffff;
    border: 1px solid #c5c5c5;
    color: #333333;
    margin-right: 30px;
    &:hover,
    :active {
      border: 1px solid #126edf;
    }
  }
  .submit-btn {
    background: #2587ff;
    color: #ffffff;
    &:hover,
    :active {
      background-color: #126edf;
    }
  }
}
</style>
